export const SYSTEM_STATUS_BAR_FLAG = 'AHA-49162-system-status-bar'

export const SYSTEM_STATUS_HEALTH_PATH = '/api/health/db'

export const SYSTEM_STATUS_CHECK_MIN_INTERVAL_MS = 30 * 1000

export const SYSTEM_STATUS_CONFIRM_DELAY_MS = 15 * 1000

export const SYSTEM_STATUS_RECHECK_INTERVAL_MS = 60 * 1000

export const SYSTEM_STATUS_REQUEST_TIMEOUT_MS = 10 * 1000

export const SYSTEM_STATUS_BAR_DEFAULT_MESSAGE = "We're having a system issue on our side and are working to fix it. Please try again in a few minutes."

export const SYSTEM_STATUS_VERDICTS = Object.freeze({
  OK: 'ok',
  DEGRADED: 'degraded',
  OUR_SIDE_PROBLEM: 'our_side_problem',
  CANNOT_REACH_US: 'cannot_reach_us_from_this_device',
})

export const STATUS_PAGE_NOTICE_FLAG = 'SYST-958-status-page-notice'

export const STATUS_PAGE_URL = 'https://status.ahaslides.com'

export const STATUS_PAGE_EVENT_FEED_PATH = '/api/getEventFeed/6m7P0SoN3Z'

export const STATUS_PAGE_MONITOR_LIST_PATH = '/api/getMonitorList/6m7P0SoN3Z'

export const STATUS_PAGE_PROXY_PREFIX = '/status-page'

export const STATUS_PAGE_PROXY_HOSTS = ['presenter.ahaslides.com', 'presenter.dev.ahaslide.com']

// UptimeRobot marks a paused or not-yet-checked monitor 'black'; that is not an outage.
export const STATUS_PAGE_NOT_DOWN_CLASSES = ['success', 'black']

export const STATUS_PAGE_NOTICE_POLL_INTERVAL_MS = 5 * 60 * 1000

export const STATUS_PAGE_DOWN_POLL_INTERVAL_MS = 60 * 1000

export const STATUS_PAGE_NOTICE_DISMISSED_KEY = 'aha_status_page_notice_dismissed_ids'

export const STATUS_PAGE_LINK_LABEL = 'See status'
